import { render } from "./PageAccessInfoPopover.vue?vue&type=template&id=2989bc72&scoped=true"
import script from "./PageAccessInfoPopover.vue?vue&type=script&lang=js"
export * from "./PageAccessInfoPopover.vue?vue&type=script&lang=js"

import "./PageAccessInfoPopover.vue?vue&type=style&index=0&id=2989bc72&lang=css"
import "./PageAccessInfoPopover.vue?vue&type=style&index=1&id=2989bc72&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.26.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2989bc72"]])

export default __exports__